module.exports = __webpack_public_path__ + "img/headerPic.e73c5db4.jpg";